// extracted by mini-css-extract-plugin
export default {"title":"Eaa-z","warning":"Faa-z","sizeOptionsLegendText":"Gaa-z"};